import { Viewer } from '@oneclick/tangerine-viewer';
import { defaultConfig } from 'app/config/environment';
import PropTypes from 'prop-types';
import React from 'react';

function ViewerContainerEmbed({
  showHeader,
  authToken,
  courseGuid,
  lang,
  user,
  contentGuid,
  pdfConfig,
  controllersConfig,
  pagesRangeShow,
  pdfLibrary,
  jobGuid,
  docConfig,
  reportErrorSentry,
  scormMetadata,
  goToBackViewer,
  externalContentUrl,
  onContentLoaded,
  onOpenExternal,
  contained,
}) {
  return (
    <div className="viewer-v2" style={{ position: 'relative', height: '100%', width: '100%' }}>
      <Viewer
        authToken={authToken}
        contentGuid={contentGuid}
        controllersConfig={controllersConfig}
        courseGuid={courseGuid}
        domain={defaultConfig.BASE_URL_}
        lang={lang}
        pagesRangeShow={pagesRangeShow}
        pdfConfig={pdfConfig}
        scormMetadata={scormMetadata}
        showHeader={showHeader}
        pdfLibrary={pdfLibrary}
        user={user}
        jobGuid={jobGuid}
        docConfig={docConfig}
        reportErrorSentry={reportErrorSentry}
        onClose={goToBackViewer}
        externalContentUrl={externalContentUrl}
        onContentLoaded={onContentLoaded}
        onOpenExternal={onOpenExternal}
        contained={contained}
      />
    </div>
  );
}

ViewerContainerEmbed.propTypes = {
  authToken: PropTypes.string.isRequired,
  contentGuid: PropTypes.string.isRequired,
  controllersConfig: PropTypes.object,
  courseGuid: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  pagesRangeShow: PropTypes.array,
  pdfConfig: PropTypes.object,
  pdfLibrary: PropTypes.string,
  showHeader: PropTypes.bool,
  user: PropTypes.object.isRequired,
  jobGuid: PropTypes.string,
  docConfig: PropTypes.object,
  reportErrorSentry: PropTypes.func,
  scormMetadata: PropTypes.object,
  goToBackViewer: PropTypes.func,
  externalContentUrl: PropTypes.string,
  onContentLoaded: PropTypes.func,
  onOpenExternal: PropTypes.func,
  contained: PropTypes.bool,
};

ViewerContainerEmbed.defaultProps = {
  pdfLibrary: '',
  contained: false,
};

export default ViewerContainerEmbed;
